import React from 'react';
import styled from 'styled-components';
import Peru from '../../Assets/TreePlanting/Peru.png';
import Tanzania from '../../Assets/TreePlanting/Tanzania.png';
import Congo from '../../Assets/TreePlanting/Congo.png';
import tree from '../../Assets/TreePlanting/Tree.png';
import growth from '../../Assets/TreePlanting/Growth.png';
import deforestation from '../../Assets/TreePlanting/Deforestation.png';

import {
  mobileMediaQuery,
  tabletMediaQuery,
  themeColor,
  useBreakPoints,
} from '../../Theming';
import { useTranslation } from 'react-i18next';

const Container = styled.div`
  width: 100%;
  height: auto;
  display: block;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  margin-bottom: 50px;
`;

const Header = styled.p`
  font-style: normal;
  font-weight: 700;
  font-size: 45px;
  line-height: 54px;
  text-align: center;
  color: ${themeColor('darkestGreen')};
  margin-bottom: 80px;

  ${mobileMediaQuery} {
    font-size: 28px;
    line-height: 34px;
    padding-left: 80px;
    padding-right: 80px;
    margin-bottom: 40px;
  }
`;

const DescriptionHeader = styled(Header)`
  font-size: 36px;
  line-height: 36px;
  margin-top: 20px;
  margin-bottom: 0px;
  text-align: left;

  ${mobileMediaQuery} {
    font-size: 25px;
    line-height: 30px;
    padding-left: 0px;
    padding-right: 0px;
  }
`;

const DescriptionText = styled(Header)`
  font-weight: 400;
  font-size: 18px;
  line-height: 29px;
  margin-bottom: 20px;
  text-align: left;

  ${mobileMediaQuery} {
    font-size: 15px;
    line-height: 25px;
    width: 100%;
    text-align: left;
    padding-left: 0px;
    padding-right: 0px;
    margin-bottom: 0px;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  height: 520px;
  display: flex;

  ${mobileMediaQuery} {
    display: block;
    height: auto;
  }
`;

const DescriptionContainer = styled.div`
  width: 50%;
  height: 520px;
  display: block;
  text-align: left;
  align-items: left;
  background-color: ${themeColor('greyWhite')};
  padding: 100px 85px 0px 85px;

  ${tabletMediaQuery} {
    width: 100%;
    padding: 40px 40px 50px 40px;
    height: auto;
  }
`;

const StyledImage = styled.img`
  width: 50%;
  height: 520px;

  ${mobileMediaQuery} {
    width: 100%;
    height: 320px;
  }
`;

const DescriptionIcon = styled.img`
  max-width: 55px;
  max-height: 55px;

  ${mobileMediaQuery} {
    max-width: 46px;
    max-height: 46px;
  }
`;

const RecentProjects: React.FC = () => {
  const { t } = useTranslation();
  const { mobile } = useBreakPoints();

  return (
    <Container>
      <Header>{t('treePlanting.recentProjects.heading')}</Header>
      <ContentContainer>
        <StyledImage src={Peru} />
        <DescriptionContainer>
          <DescriptionIcon src={tree} />
          <DescriptionHeader>
            {t('treePlanting.recentProjects.restoringForests.heading')}
          </DescriptionHeader>
          <DescriptionText>
            {t('treePlanting.recentProjects.restoringForests.description')}
          </DescriptionText>
        </DescriptionContainer>
      </ContentContainer>
      <ContentContainer>
        {mobile && <StyledImage src={Tanzania} />}
        <DescriptionContainer>
          <DescriptionIcon src={growth} />
          <DescriptionHeader>
            {t('treePlanting.recentProjects.plantingForests.heading')}
          </DescriptionHeader>
          <DescriptionText>
            {t('treePlanting.recentProjects.plantingForests.description')}
          </DescriptionText>
        </DescriptionContainer>
        {!mobile && <StyledImage src={Tanzania} />}
      </ContentContainer>
      <ContentContainer>
        <StyledImage src={Congo} />
        <DescriptionContainer>
          <DescriptionIcon src={deforestation} />
          <DescriptionHeader>
            {t('treePlanting.recentProjects.preventingDeforestation.heading')}
          </DescriptionHeader>
          <DescriptionText>
            {t(
              'treePlanting.recentProjects.preventingDeforestation.description'
            )}
          </DescriptionText>
        </DescriptionContainer>
      </ContentContainer>
    </Container>
  );
};

export default RecentProjects;
